<template>
  <div id="container" v-if="fetch_data">

    <section id="mypage">
      <div class="wrap">

        <!-- オンラインショップ購入履歴 -->
        <div class="cts_box">
          <h2 class="sub_ttl"><span>動画レンタル履歴</span></h2>
          <p class="lead_txt">
            「動画レンタル」いただいた講義の一覧です。
          </p>

          <div class="online_shop_box">
            <div class="order_group" v-for="sale in fetch_data" v-bind:key="sale.id">
              <ul class="online_shop_list movie">
                <li>
                  <div class="buy_data flex">
                    <table>
                      <tbody>
                      <tr class="head">
                        <th class="date">ご注文日</th>
                        <th class="price">金額</th>
                        <th class="sns_post">視聴可能期間</th>
                      </tr>
                      <tr>
                        <td class="date"><span class="sp">ご注文日：</span>{{ moment(sale.payment_at, 'YYYY年MM月DD日') }}</td>
                        <td class="price"><span class="sp">金額：</span>¥ {{ delimited(sale.price) }}</td>
                        <td class="access_period_at"><span class="sp">視聴可能期間：</span>
                          <template v-if="sale.access_period_at">
                            {{ moment(sale.access_period_at, 'YYYY年M月D日') }}まで
                          </template>
                          <template v-else>
                            ※ 無制限
                          </template>
                        </td>
                      </tr>
                      </tbody>
                    </table>
                    <div class="btn pc" v-if="sale.readable">
                      <router-link :to="{ name: 'SnsPost', params: {post_id: sale.sns_post_sale.sns_post_id} }" class="linkBtn">
                        視聴する
                      </router-link>
                    </div>
                    <div class="btn pc" v-else>
                      <router-link :to="{ name: 'SnsPostSale', params: {id: sale.sns_post_sale.id} }" class="linkBtn green">
                        再レンタルする
                      </router-link>
                    </div>
                  </div>
                  <div class="detail flex">
                    <div class="icon">
                      <img v-bind:src="sale.sns_post_sale.video_picture_url" alt="">
                    </div>
                    <div class="contents">
                      <h3>{{ sale.sns_post_sale.title }}</h3>
                      <div class="mov_txt">
                        <p>{{ sale.sns_post_sale.description }}</p>
                      </div>
                    </div>
                    <div class="btn sp" v-if="sale.readable">
                      <router-link :to="{ name: 'SnsPost', params: {post_id: sale.sns_post_sale.sns_post_id} }" class="linkBtn">
                        視聴する
                      </router-link>
                    </div>
                    <div class="btn sp" v-else>
                      <router-link :to="{ name: 'SnsPostSale', params: {id: sale.sns_post_sale.id} }" class="linkBtn">
                        再レンタルする
                      </router-link>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>

          <div class="button_wrap">
            <a @click="$router.go(-1)" class="submit arrow back light skeleton large">戻る</a>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>

import Libraries from '@/components/Libraries'

export default {
  mixins: [Libraries],
  data() {
    return {
      fetch_data: null,
    }
  },
  mounted() {
    this.fetchData()
  },
  methods: {
    fetchData() {
      this.startAjax()
      this.axios
          .get(`${this.env.api_base_url}users/sns_post_sales.json`, {
          })
          .then(response => {
            this.fetch_data = response.data
          })
          .catch((response) => {
            this.errorAjax(response)
          })
          .finally(() => {
            this.finishAjax()
          })
    },
    onShoppingDetailClicked(shopping) {
      this.shopping_id = shopping.id
    },
    receiptDownload(shopping) {
      location.href = `${this.env.api_base_url}users/receipt_download.pdf?id=${shopping.user_receipt_id}&token=${this.current_user.api_token}`
    },
  }
}
</script>
